module.exports = __webpack_public_path__ + "static/img/home_icon_shop.e11b4ae3.png";